import { cssVar } from '@fabric-app/ui/theme/variables';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const SearchBarButton = styled(motion.button).attrs({
  type: 'button',
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
})`
  display: flex;
  width: 40px;
  height: 40px;
  flex-shrink: 0;

  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: transparent;
  color: ${cssVar['color-text-primary']};
  transition: background 0.2s;

  svg {
    width: 1.0375rem;
    height: 1.0375rem;
  }

  svg[data-fabric-icon-v2='navigational-24'] {
    font-size: 24px;
    width: 24px;
    height: 24px;
  }

  ${mediaHover} {
    &:hover {
      background: ${cssVar['color-bg-quarternary']};
    }
  }
`;
